"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDataPackageCell = exports.createPayloadCell = void 0;
const redstone_constants_1 = require("redstone-protocol/src/common/redstone-constants");
const ton_core_1 = require("ton-core");
const utils_1 = require("ethers/lib/utils");
const assert_1 = __importDefault(require("assert"));
const split_payload_hex_1 = require("./split-payload-hex");
function createPayloadCell(payloadHex) {
    const { dataPackageChunks, metadata } = (0, split_payload_hex_1.splitPayloadHex)(payloadHex);
    (0, assert_1.default)(dataPackageChunks.length <= 16, `Must be implemented for larger data (${dataPackageChunks.length} > 16)`);
    let lastCellIndex = -1;
    const payloadCell = (0, ton_core_1.beginCell)().storeBuffer(Buffer.from((0, utils_1.arrayify)("0x" + metadata)));
    let cell = (0, ton_core_1.beginCell)();
    for (let i = 0; i <= dataPackageChunks.length; i++) {
        const payloadCellIndex = Math.floor(i / 4);
        if ((payloadCellIndex !== lastCellIndex && i !== 0) ||
            i === dataPackageChunks.length) {
            payloadCell.storeRef(cell);
            if (i === dataPackageChunks.length) {
                break;
            }
            cell = (0, ton_core_1.beginCell)();
        }
        lastCellIndex = payloadCellIndex;
        const dataPackageCell = createDataPackageCell(dataPackageChunks[i]);
        cell.storeRef(dataPackageCell);
    }
    return payloadCell.endCell();
}
exports.createPayloadCell = createPayloadCell;
function createDataPackageCell(dataPackageHex) {
    const data = dataPackageHex.substring(0, dataPackageHex.length - 2 * redstone_constants_1.SIGNATURE_BS);
    const signature = dataPackageHex.substring(dataPackageHex.length - 2 * redstone_constants_1.SIGNATURE_BS, dataPackageHex.length);
    const v = BigInt("0x" + signature.substring(128, 130));
    (0, assert_1.default)([27, 28].map(BigInt).includes(v), `Wrong signature 'v' value (${v})`);
    const signatureCell = (0, ton_core_1.beginCell)()
        .storeUint(BigInt("0x" + signature.substring(0, 64)), 256)
        .storeUint(BigInt("0x" + signature.substring(64, 128)), 256)
        .storeUint(v, 8)
        .endCell();
    console.assert(data.length / 2 <= 127, "Must be implemented for larger data");
    const dataCell = (0, ton_core_1.beginCell)()
        .storeBuffer(Buffer.from((0, utils_1.arrayify)("0x" + data)))
        .endCell();
    return (0, ton_core_1.beginCell)()
        .storeSlice(signatureCell.beginParse())
        .storeRef(dataCell)
        .endCell();
}
exports.createDataPackageCell = createDataPackageCell;
//# sourceMappingURL=create-payload-cell.js.map